import { IconButton, Tooltip, Box } from "@radix-ui/themes";
import { ReloadIcon } from "@radix-ui/react-icons";

interface RefetchButtonProps {
  timeElapsed: string;
  isPredictionFetching: boolean;
  onRefetch: () => void;
}

export const RefetchButton = ({
  timeElapsed,
  isPredictionFetching,
  onRefetch,
}: RefetchButtonProps) => {
  return (
    <Tooltip
      content={
        <Box style={{ textAlign: "center" }}>
          <Box>Last updated {timeElapsed} ago.</Box>
          <Box>Press to update</Box>
        </Box>
      }
    >
      <IconButton
        size="1"
        variant="ghost"
        color="gray"
        onClick={onRefetch}
        highContrast
        disabled={isPredictionFetching}
        className="flex-shrink-0"
      >
        <ReloadIcon className={isPredictionFetching ? "animate-spin" : ""} />
      </IconButton>
    </Tooltip>
  );
};
